import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../Button/Button';
import { DialogBox } from '../DialogBox/DialogBox';
export const MarkAsReadDialog = ({ open, onClose, markAllRead }) => {
    const { t: text } = useTranslation();
    const markAsRead = () => {
        markAllRead();
        onClose();
    };
    return (_jsxs(DialogBox, { title: text('MARK_ALL_AS_READ'), text: text('MESSAGES_READ'), showDialog: open, handleClose: onClose, children: [_jsx(ActionButton, { type: 'primary', text: text('YES'), onClick: markAsRead, sectionName: 'Inbox', buttonType: 'Button', buttonClickText: 'Yes mark all as read' }), _jsx(ActionButton, { type: 'secondary', text: text('NO'), onClick: onClose, sectionName: 'Inbox', buttonType: 'Button', buttonClickText: 'No do not mark all as read' })] }));
};
